// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep
  .multiselect-dropdown {
    transform: translate(-3px, -7px);
    z-index: 10000 !important
  }
::ng-deep
  .multiselect-dropdown .dropdown-btn {
    border: none !important
  }
`, "",{"version":3,"sources":["webpack://./src/app/views/administration/admin/fuelseu/fuelseu-details/fuelseu-details.component.css"],"names":[],"mappings":"AAAA;;IAEI,gCAAgC;IAChC;EACF;AACF;;IAEI;EACF","sourcesContent":["::ng-deep\r\n  .multiselect-dropdown {\r\n    transform: translate(-3px, -7px);\r\n    z-index: 10000 !important\r\n  }\r\n::ng-deep\r\n  .multiselect-dropdown .dropdown-btn {\r\n    border: none !important\r\n  }\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
